import React from "react";
import { connect } from "react-redux";
import { getIsDialogOpen, setIsOpenDialog } from "../../redux/dialogs";
import { HubButton } from "../inputs";

export const DialogHubButton = ({
  name,
  onClick,
  children,
  open = false,
  value = true,
  _setIsOpenDialog = () => {},
  ...rest
}) => {
  const handleClick = (e) => {
    onClick && onClick(e);
    const newValue = open ? false : value;
    name && _setIsOpenDialog(name, newValue);
  };

  return (
    <HubButton {...rest} onClick={handleClick}>
      {children}
    </HubButton>
  );
};

const mapStateToProps = (state, ownProps) => ({
  open: getIsDialogOpen(state, ownProps.name),
});
const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};
export const DialogButton = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DialogHubButton);
